module.exports = __webpack_public_path__ + "static/media/embadYoutube.0259bf9b.png";